import './_mini-cart-header.scss';

export default () => {};
